import { render, staticRenderFns } from "./SwcdForm.vue?vue&type=template&id=07ff0c56&"
import script from "./SwcdForm.vue?vue&type=script&lang=js&"
export * from "./SwcdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports